export const roundToPrecision = (value, precision, average) => {
  if (typeof value !== "number" || typeof precision !== "number") return value;
  if (typeof average !== "number") return value;

  if (precision === 1) return Math.round(value);

  const factor = Math.pow(10, -Math.log10(precision));
  const roundedValue =
    value > average
      ? Math.floor(value * factor) / factor
      : Math.ceil(value * factor) / factor;

  return roundedValue;
};
